import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {Content, DateTime, Header, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {ENUM, TAction} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {UsuarioMenuPage} from "../usuario-menu/usuario-menu";
import {HotspotService} from "../../../providers/hotspot-service";
import {WebstorOpenPage} from "../webstor-open/webstor-open";
import {ModalActionPage} from '../modal-action/modal-action';

export enum TWorkdayFlag {msWorkdayDone, msWorkdayGelo, msWorkdayOpen}
@Component({
    selector: 'page-workday-code',
    templateUrl: 'workday-code.html',
    providers: [WebstorService, HotspotService]
})
export class WorkdayCodePage {

    ENUM: any = ENUM;
    config: any;
    
    
    //Workday - etapa 2
    TWorkdayFlag: any = TWorkdayFlag;
    codedaySeta: number;
    workdayJson: any;
    comandaFind: any;
    loading: boolean;


    logado: any;
    rootile: any;
    pulsed: boolean;

    etapa: number;
    userset: any;

    workday: any;
    rootspot: any;
    copyspot: any;


    @ViewChild(Header) header: Header;
    @ViewChild(Content) content: Content;
    @ViewChild(DateTime) iondate: DateTime;

    constructor(private viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public util: Util,
                public webstorService: WebstorService, public hotspotService: HotspotService,
                public logadoService: LogadoService) {

        this.pulsed = false;
        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.etapa = this.navParams.get('etapa');
        this.userset = this.navParams.get('userset');

        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Hotspot Menu', '/hotspot-menu');


        let pageOlha = (this.copyspot.Hotspots[0].HotspotCode && this.userset.FlagCoin);
        this.codedaySeta = (pageOlha ? 1 : 0);

        if (this.etapa == 2 && this.codedaySeta == 0) this.workdayCode(false);
        if (this.etapa == 2 && this.codedaySeta == 1) this.monitorLoad();

    }

    getTitle(): string {

        if (!this.copyspot) return 'Hotspot';

        if (this.etapa == 2) return 'OLHAKI';

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }




    /** ************************************************ HOTSPOT ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    usuarioOpen(usuario) {

        let autorizar = (usuario.Departa ? 'Editar' : 'Autorizar');

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: autorizar, handler: () => this.usuarioMenu(usuario)});
        buttons.push({text: 'Remover', handler: () => this.usuarioLixo(usuario), role: 'destructive'});
        this.util.sheetOpen(buttons, this.util.nomeLast(usuario.Profile.ProfileShow));

    }

    usuarioLixo(usuario) {

        let onLixo = () => {
            let index = this.workday.Usuarios.findIndex(US => US.Profile.ProfileID == usuario.Profile.ProfileID);
            this.workday.Usuarios.splice(index, 1);
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.usuario(TAction.acLixo, this.copyspot.Hotspots[0].HotspotID, usuario.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLixo(),
                erro => this.util.alertResult(erro)
            );

    }

    usuarioMenu(usuario) {

        //Perfil JÁ esta adicionado, mostra!
        let etapa = (usuario.Departa ? 0 : 1);
        let object = {etapa: etapa, rootile: this.rootile, usernew: false, userset: this.userset, usuario: usuario, rootspot: this.rootspot, copyspot: this.copyspot};
        this.util.modalopen(UsuarioMenuPage, 'alto', false, object).subscribe(
            data => {
                if (data.deleted) {
                    let index = this.workday.Usuarios.findIndex(US => US.Profile.ProfileID == usuario.Profile.ProfileID);
                    this.workday.Usuarios.splice(index, 1);
                }
            });

    }











    /** ************************************************* WORKDAY ************************************************* **/
    /** ************************************************* etapa-2 ************************************************* **/

    workdayCode(codenew: boolean) {

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.webstor(TAction.acCode, this.rootile.Profile.ProfileID, this.copyspot.Hotspots[0].HotspotID, '', false, codenew)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.workday = data;
                    setTimeout(() => this.workday._animated = true, 1500); //Tempo da animação para não exibir a classe fadeIn
                    this.copyspot.Hotspots[0].HotspotCode = data.Codeday;
                    this.copyspot.Hotspots[0].Projeto = data.Projeto;
                    this.util.populateObj(this.rootspot, this.copyspot);

                },
                erro => {

                    this.util.alertPopula(erro, this.rootspot, this.copyspot);

                });

    }

    projetoSpot(projeto) {

        let onSave = (projeto) => {
            this.copyspot.Hotspots[0].Projeto = projeto;
            this.util.populateObj(this.rootspot, this.copyspot);
        };

        let params = '&HotspotID=' + this.copyspot.Hotspots[0].HotspotID;
        let json = projeto;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.projeto(TAction.acSpot, json, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(projeto),
                erro => this.util.alertPopula(erro, this.rootspot, this.copyspot)
            );

    }

    projetoOpen() {

        if (!this.userset.FlagTeam && !this.copyspot.Hotspots[0].Projeto) {
            this.util.toastSimply('Para ativar contate o suporte!');
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&HotspotID=' + this.copyspot.Hotspots[0].HotspotID;

        this.webstorService.projeto(TAction.acLoad, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.projetoSort(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    projetoSort(data) {

        let projetoStar = [];
        if (data.Projetos) data.Projetos.forEach(PJ => PJ.Projetos.forEach(JJ => projetoStar.push(JJ)));
        projetoStar = this.util.arraySort(projetoStar, 'ProjetoStar');
        projetoStar.reverse();

        //Pega os 5+
        projetoStar = projetoStar.filter((PJ, IN) => PJ.ProjetoStar > 0 && IN < 4);

        let buttons: Array<any> = [];
        projetoStar.forEach(PJ => buttons.push({text: PJ.ProjetoNome, handler: () => this.projetoSpot(PJ)}));
        buttons.push({text: 'Ver mais', cssClass: this.util.sheetClass(), handler: () => this.projetoMenu()});
        this.util.sheetOpen(buttons, 'PROJETOS');

    }

    projetoMenu() {

        let onSave = (projeto) => {
            this.copyspot.Hotspots[0].Projeto = projeto;
            this.projetoSpot(projeto);
        };

        let objectPrj = {homeb: false, etapa: 0, title: null, keyname: 'Projeto', toggler: 'hide', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, objectPrj).subscribe(data => onSave(data[0]));

    }




    /** ************************************************* OLHAKI  ************************************************* **/
    /** ************************************************* etapa-4 ************************************************* **/

    workdayFlag() {

        //Open vs Close
        let onOkey = (okey, that, data) => this.workdayDesk(that);

        let bool = (this.workdayJson && this.workdayJson.WorkdayFlag == TWorkdayFlag.msWorkdayDone);

        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'workday', onOkey, onOkey, bool)};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    workdayDesk(that) {

        let novo = (this.workdayJson && this.workdayJson.WorkdayFlag == TWorkdayFlag.msWorkdayDone);
        let code = (this.workdayJson ? this.workdayJson.WorkdayID : 0);

        let loading = this.util.loadingDots();
        loading.present();

        let action = (novo ? TAction.acNovo : TAction.acDone);
        let params = (novo ? '': '&WorkdayID=' + code);
        this.util.monitorDesk(false, 'DESK-Workday', this.copyspot.Hotspots[0].HotspotID, params, action)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    that.dismiss();
                    this.monitorLoad();
                },
                erro => this.util.alertResult(erro)
            );

    }

    monitorLoad() {
        
        this.loading = true;

        let action: TAction;
        //ANO -> action = TAction.acList;
        //MES -> action = TAction.acLoad;
        if (this.etapa == 2) action = TAction.acInfo;
            
        let params = '&WorkdayID=' + 0 + '&WorkdayIZ=' + 0;

        this.util.monitorDesk(false, 'DESK-Workday', this.copyspot.Hotspots[0].HotspotID, params, action)
            .finally(() => this.loading = false)
            .subscribe(
                data => this.workdayJson = data.Workdays[0],
                erro => this.util.alertResult(erro)
            );

    }

    paybookFind() {

    }

    

    dismiss() {

        if ( this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        if (!this.viewCtrl.isOverlay) this.navCtrl.pop();

    }

    
}



// WEBPACK FOOTER //
// ./src/pages/sync/workday-code/workday-code.ts